import { h } from 'preact';
import { isFocusStudio } from 'utils/studioConfig';

import UniversalVideosEditor from 'components/editor/movies/videos/videosUniversal';

export default (props) => {
	if (isFocusStudio()) return null;
	return <UniversalVideosEditor {...props} />;
};